import { IBaseAddress } from '../../../../1stlog-ui/src/types'
import { request } from '../../../../1stlog-ui/src/utils'
import { TAddressSearchSuggestion } from './types'

export async function requestAddressSearch(
  values: IBaseAddress,
  { url, customerId },
): Promise<TAddressSearchSuggestion[]> {
  const { data } = await request<{ data: TAddressSearchSuggestion[] }>({
    method: 'post',
    url: `${url}/search`,
    data: { ...values, customerId },
  })
  return data?.data ?? []
}
